import DOMPurify from "dompurify";
import { EditorState, RawDraftContentState, convertFromRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import localization from "./config/localization";
import toolbar from "./config/toolbar";
//import "./styles/style.css";
//import "/src/global.css";
import {
  FractionChildProps,
  FractionProps,
  PostFraction,
} from "../../Fraction";
import { DisplayMode } from "../../../Post";
import { AliasType } from "../../../../PostFlow";
import { aliasReplacement } from "../../fractionHelpers";

export type TextState = string;

export function stateToHtml(state: RawDraftContentState) {
  const sanitizedState = DOMPurify.sanitize(
    draftToHtml(state)
      //.replace(/\n/g, "<br>") // Keep multiple new lines when displaying
      .replace(/  /g, "&nbsp; "), // Keep multiple spaces
    {
      ADD_ATTR: ["target"],
    }
  );
  return sanitizedState;
}

export function stateToString(state: RawDraftContentState) {
  return JSON.stringify(state);
}

export function stringToState(stateStr?: string): RawDraftContentState {
  const emptyState = { blocks: [], entityMap: {} };

  if (stateStr === undefined) {
    return emptyState;
  }

  try {
    return JSON.parse(stateStr) as RawDraftContentState;
  } catch {
    return emptyState;
  }
}

function TextEditorAndViewer(props: FractionChildProps<string>) {
  if (props.mode === DisplayMode.EDIT) {
    return <TextEditor {...props} />;
  } else {
    return <TextViewer {...props} />;
  }
}

function TextViewer(props: FractionChildProps<string>) {
  const state = stringToState(aliasReplacement(props.state, props.alias));

  if (isEmptyState(state)) {
    return <div>INSERT TEXT HERE</div>;
  }

  return (
    <div
      style={{
        marginLeft: "15px",
      }}
      dangerouslySetInnerHTML={{
        __html: stateToHtml(state),
      }}
    />
  );
}

function isEmptyState(state: RawDraftContentState | undefined) {
  return (
    state === undefined ||
    state.blocks.length === 0 ||
    (state.blocks.length === 1 && /^\s*$/.test(state.blocks[0].text))
  );
}

function TextEditor(props: FractionChildProps<TextState>) {
  const [editorState, setEditorState] = useState(
    props.state
      ? EditorState.createWithContent(
          convertFromRaw(stringToState(props.state))
        )
      : EditorState.createEmpty()
  );

  const handleContentStateChange = (state: RawDraftContentState) => {
    if (props.onChange) {
      if (isEmptyState(state)) {
        return;
      }
      props.onChange(stateToString(state));
    }
  };

  return (
    <div
      className="base_editor"
      style={{
        margin: "20px",
        marginTop: "20px",
        borderColor: "#999999",
        borderRadius: "10px",
        borderWidth: "1px",
        background: "white",
        padding: "30px 0 0 0",
        lineHeight: "30px",
      }}
    >
      <div
        style={{
          margin: "20px",
          marginTop: "20px",
        }}
      >
        <Editor
          editorState={editorState}
          toolbarClassName="editor-toolbar"
          wrapperClassName="editor-wrapper"
          editorClassName="editor"
          onEditorStateChange={setEditorState}
          onContentStateChange={handleContentStateChange}
          toolbar={toolbar}
          localization={localization}
          spellCheck
          toolbarCustomButtons={
            [
              //<Star onChange={handleEditorStateChange} editorState={editorState} />,
            ]
          }
        />
        {/*<Editor editorState={editorState} toolbar={{ options: [] }} readOnly />*/}
      </div>
    </div>
  );
}

export const TextFraction = (props: FractionProps<string>) => {
  return (
    <PostFraction {...props}>
      <TextEditorAndViewer />
    </PostFraction>
  );
};
